import { render, staticRenderFns } from "./AppBtnCollapse.vue?vue&type=template&id=fe3f43bc&scoped=true&"
import script from "./AppBtnCollapse.vue?vue&type=script&lang=ts&"
export * from "./AppBtnCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./AppBtnCollapse.vue?vue&type=style&index=0&id=fe3f43bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3f43bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VIcon,VLayout})
